/* eslint-disable import/no-unresolved */
<template>
  <component :is="iconComponent" role="img" :class="className" />
</template>
<script>
const icons = {};

const requireComponents = require.context("../../assets/icons", false, /.svg$/);

requireComponents.keys().forEach((fileName) => {
  const iconName = fileName.replace(/^\.\/icon-(.+)\.svg$/, "$1");
  const componentConfig = requireComponents(fileName);
  icons[iconName] = componentConfig.default || componentConfig;
});
export default {
  props: {
    name: {
      type: String,
      required: true,
      validator(value) {
        return Object.prototype.hasOwnProperty.call(icons, value);
      },
    },
    className: {
      type: String,
    },
  },
  computed: {
    iconComponent() {
      return icons[this.name];
    },
  },
};
</script>
